<template>
  <div class="governance-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/gov/header-img.png" />
      <div class="header-title">
        Governance
        <div class="header-text" v-if="activeName !== 'Introductions' && this.$store.state.webType !== 'h5'">
          (Text No.6)he World Congress is the supreme organ of the World
          Federation, which consists of the representatives of WFUCA’s Members.
          It meets every four years. <br />
          The World Congress determines the General Rules and the guidelines of
          work of the Organization. Its duty is to set the programmes and the
          budget of WFUCA. It also elects the Members of the Executive Board and
          the President.
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- <el-tab-pane label="Introductions" name="Introductions">
        <gov-introductions></gov-introductions>
      </el-tab-pane> -->
      <el-tab-pane label="World Congress" name="World">
        <gov-world></gov-world>
      </el-tab-pane>
      <el-tab-pane label="Executive Board" name="Executive">
        <gov-executive></gov-executive>
      </el-tab-pane>
      <el-tab-pane label="The Secretariat" name="Secretariat">
        <gov-secretariat></gov-secretariat>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import GovIntroductions from "./components/GovIntroductions.vue";
import GovWorld from "./components/GovWorld.vue";
import GovExecutive from "./components/GovExecutive.vue";
import GovSecretariat from "./components/GovSecretariat.vue";
export default {
  components: {
    GovIntroductions,
    GovWorld,
    GovExecutive,
    GovSecretariat,
  },
  data() {
    return {
      activeName: "World",
      constants: {},
    };
  },
  methods: {
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .governance-page {
    padding-top: 50px;
    .page-header {
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      .header-title {
        position: absolute;
        left: fw(205vw, pc);
        bottom: fh(36vh, pc);
        font-size: fh(48vh, pc);
        color: #ffffff;
        line-height: fh(58vh, pc);
      }
    }
    ::v-deep .el-tabs {
      .el-tabs__header{
        padding: 0  10px !important;
      }
      .el-tabs__content {
        padding: 0 !important;
      }
      .el-tabs__nav-scroll {
        padding: 10px 0 !important;
      }
      .el-tabs__nav-next,
      .el-tabs__nav-prev, {
        margin-top: 8px;
      }
    }
  }
}
.governance-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
      .header-text {
        font-size: fh(17vh, pc);
        line-height: fh(28vh, pc);
        margin-top: fh(26vh, pc);
        width: calc(100% - 10.416vw);
      }
    }
  }
  ::v-deep .el-tabs {
    width: 100%;
    .el-tabs__content {
      padding: fh(60vh, pc) fw(200vw, pc);
    }
    .el-tabs__header {
      width: 100%;
      left: 0;
      background: #ececec;
      padding: 0 fw(200vw, pc);
      margin-bottom: 0;
    }
    .el-tabs__nav-scroll {
      padding: fh(30vh, pc) 0 !important;
    }
    .el-tabs__item {
      font-size: fh(16vh, pc);
      color: #999999;
      &.is-active {
        color: #333333;
        font-size: fh(18vh, pc);
      }
    }
    .el-tabs__active-bar {
      bottom: fh(-30vh, pc);
      background: #0077d4;
    }
  }
}
</style>
